import { useState, useEffect } from 'react';
import { EventProps } from '../components/EventCard';
import { subscribeToApprovedEvents, Event as FirebaseEvent } from '../firebase/events-service';
import { DEFAULT_EVENT_IMAGE } from '../constants/images';
import { sortEventsByDateNewestFirst } from '../utils/dateUtils';

// Helper function to check if an event date is in the future or today (currently unused)
// const isEventCurrent = (dateString: string): boolean => {
//   const eventDate = parseEventDate(dateString);
//   const today = new Date(2025, 5, 7); // June 7, 2025 (month is 0-indexed)
//   today.setHours(0, 0, 0, 0); // Set to start of today
//   
//   return eventDate >= today;
// };

// Convert Firebase Event to EventProps format
const convertFirebaseEventToEventProps = (fbEvent: FirebaseEvent): EventProps => {
  return {
    id: fbEvent.id || '',
    title: fbEvent.title,
    date: fbEvent.date,
    location: fbEvent.location,
    description: fbEvent.description,
    imageUrl: fbEvent.imageUrl || DEFAULT_EVENT_IMAGE,
    type: fbEvent.type,
    externalUrl: fbEvent.externalUrl
  };
};

export const useAllEvents = () => {
  const [firebaseEvents, setFirebaseEvents] = useState<EventProps[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('Setting up real-time Firebase events listener...');
    
    setLoading(true);
    
    // Set up real-time listener
    const unsubscribe = subscribeToApprovedEvents((approvedEvents) => {
      console.log(`Received ${approvedEvents.length} approved events from Firebase`);
      
      const convertedEvents = approvedEvents.map(convertFirebaseEventToEventProps);
      setFirebaseEvents(convertedEvents);
      setError(null);
      setLoading(false);
    });

    // Cleanup function to unsubscribe when component unmounts
    return () => {
      console.log('Cleaning up Firebase events listener...');
      unsubscribe();
    };
  }, []);

  // Only use Firebase events now (no hardcoded events)
  const allEvents = [...firebaseEvents];

  // Show all events without date filtering
  const currentEvents = allEvents;

  // Sort events by date (newest first) using the utility function
  const sortedEvents = sortEventsByDateNewestFirst(currentEvents);

  const refreshEvents = async () => {
    console.log('Manual refresh requested (real-time listener should handle this automatically)');
    
    try {
      setLoading(true);
      setError(null);
    } catch (err) {
      console.error('Error refreshing Firebase events:', err);
      setError('Failed to refresh events');
    } finally {
      setLoading(false);
    }
  };

  return {
    events: sortedEvents,
    firebaseEvents,
    hardcodedEvents: [], // No hardcoded events anymore
    loading,
    error,
    refreshEvents
  };
};
